export const getHoursFromTimeslot = (timeslot: string) => {
  const hourString = timeslot.split(' ')[0]
  const [hour, minutes] = hourString.split(':')

  return {
    hours: hourString.includes('p.m.') ? +hour + 12 : +hour,
    minutes: +minutes,
  }
}

export const getHoursFromDuration = (duration: number, timeToAdd: { hours: number; minutes: number }) => {
  return {
    hours: Math.floor(duration) + timeToAdd.hours,
    minutes: Math.round((duration % 1) * 60) + timeToAdd.minutes,
  }
}

export const convertDate = (date: string) => {
  const data = date.replace('T', ' ')
  return data.trim()
}

/** Transform 24hr time format to 12hr format */
export const transformTime = (slot: string) => {
  const time = slot.split(':')
  const hour = parseInt(time[0])
  const minutes = time[1]

  if (hour === 12) {
    return `${hour}:${minutes} p.m.`
  }
  if (hour > 12) {
    return `${hour - 12}:${minutes} p.m.`
  }
  return `${hour}:${minutes} a.m.`
}
